"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable consistent-return */
const proto_1 = __importDefault(require("@helium/proto"));
const JSLong = __importStar(require("long"));
const Transaction_1 = __importDefault(require("./Transaction"));
const utils_1 = require("./utils");
class TokenBurnV1 extends Transaction_1.default {
    constructor(opts) {
        super();
        this.type = 'token_burn_v1';
        this.payer = opts.payer;
        this.payee = opts.payee;
        this.amount = opts.amount;
        this.nonce = opts.nonce;
        this.memo = opts.memo;
        this.fee = opts.fee === undefined ? this.calculateFee() : opts.fee;
        this.signature = opts.signature;
    }
    serialize() {
        const BlockchainTxn = proto_1.default.helium.blockchain_txn;
        const tokenBurn = this.toProto();
        const txn = BlockchainTxn.create({ tokenBurn });
        return BlockchainTxn.encode(txn).finish();
    }
    message() {
        const TokenBurnTxn = proto_1.default.helium.blockchain_txn_token_burn_v1;
        const tokenBurn = this.toProto(true);
        return TokenBurnTxn.encode(tokenBurn).finish();
    }
    async sign({ payer: payerKeypair }) {
        const serialized = this.message();
        this.signature = await payerKeypair.sign(serialized);
        return this;
    }
    toProto(forSigning = false) {
        const TokenBurnTxn = proto_1.default.helium.blockchain_txn_token_burn_v1;
        const memoBuffer = Buffer.from(this.memo, 'base64');
        const memoLong = JSLong.fromBytes(Array.from(memoBuffer), true, true);
        return TokenBurnTxn.create({
            payer: utils_1.toUint8Array(this.payer.bin),
            payee: utils_1.toUint8Array(this.payee.bin),
            amount: this.amount,
            nonce: this.nonce,
            signature: this.signature && !forSigning ? utils_1.toUint8Array(this.signature) : null,
            fee: this.fee,
            memo: !memoLong.isZero() ? memoLong : undefined,
        });
    }
    static fromString(serializedTxnString) {
        var _a;
        const buf = Buffer.from(serializedTxnString, 'base64');
        const { tokenBurn } = proto_1.default.helium.blockchain_txn.decode(buf);
        const payer = utils_1.toAddressable(tokenBurn === null || tokenBurn === void 0 ? void 0 : tokenBurn.payer);
        const payee = utils_1.toAddressable(tokenBurn === null || tokenBurn === void 0 ? void 0 : tokenBurn.payee);
        const amount = utils_1.toNumber(tokenBurn === null || tokenBurn === void 0 ? void 0 : tokenBurn.amount) || 0;
        const nonce = utils_1.toNumber(tokenBurn === null || tokenBurn === void 0 ? void 0 : tokenBurn.nonce);
        const memo = utils_1.toString(tokenBurn === null || tokenBurn === void 0 ? void 0 : tokenBurn.memo) || '';
        const fee = utils_1.toNumber(tokenBurn === null || tokenBurn === void 0 ? void 0 : tokenBurn.fee);
        const signature = ((_a = tokenBurn === null || tokenBurn === void 0 ? void 0 : tokenBurn.signature) === null || _a === void 0 ? void 0 : _a.length) ? utils_1.toUint8Array(tokenBurn === null || tokenBurn === void 0 ? void 0 : tokenBurn.signature)
            : undefined;
        if (!payee || !payer || !amount || nonce === undefined)
            return;
        return new TokenBurnV1({
            payer, payee, amount, nonce, memo, fee, signature,
        });
    }
    calculateFee() {
        this.signature = utils_1.EMPTY_SIGNATURE;
        const payload = this.serialize();
        return Transaction_1.default.calculateFee(payload);
    }
}
exports.default = TokenBurnV1;
//# sourceMappingURL=TokenBurnV1.js.map